import { useEffect, useState } from "react";

let deferredPromptGlobal = null;

export function useInstallPrompt() {
  const [canInstall, setCanInstall] = useState(!!deferredPromptGlobal);
  const [installed, setInstalled] = useState(false);
  const isIOS = typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) setInstalled(true);
    const onPrompt = (e) => { e.preventDefault(); deferredPromptGlobal = e; setCanInstall(true); };
    const onInstalled = () => { setInstalled(true); setCanInstall(false); deferredPromptGlobal = null; };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const promptInstall = async () => {
    if (!deferredPromptGlobal) return false;
    deferredPromptGlobal.prompt();
    await deferredPromptGlobal.userChoice;
    deferredPromptGlobal = null;
    setCanInstall(false);
    return true;
  };

  return { canInstall, installed, isIOS, promptInstall };
}
